import { FC } from 'react'
import { DateTime } from 'luxon'
import { NumberOfTicketItems } from '@/root/components/tuuleliinid/NumberOfTicketItems/NumberOfTicketItems'
import { ClockIcon } from '@/icons/ClockIcon'
import { useGetTranslations } from '@/root/shared-hooks'
import { RowContainer } from '@/root/modules/tuuleliinid'
import { CalendarIcon } from '@/root/ui/tuuleliinid/icons/CalendarIcon'
import { ShipShortIcon } from '@/icons/ShipShortIcon'
import cn from 'classnames'

interface DepartureAndVesselInfoProps {
  cancelled: boolean
  departure: string
  numOfCycles: number
  numOfPassengers: number
  vesselTitle: string
  cancelledByAdmin?: boolean
}

const DepartureAndVesselInfo: FC<DepartureAndVesselInfoProps> = ({
  departure,
  vesselTitle,
  numOfPassengers,
  numOfCycles,
  cancelled,
  cancelledByAdmin,
}) => {
  const { getTranslation } = useGetTranslations()

  const departureDate = DateTime.fromISO(departure)
  const formattedDate = departureDate.toFormat('dd.MM.yyyy')
  const formattedTime = departureDate.toFormat('HH:mm')
  const iconColor = cancelled ? 'error' : 'black'
  const rowClassName = cn('flex items-center gap-4 lg:gap-10 text-xl leading-none', {
    'text-error': cancelled,
  })

  return (
    <RowContainer>
      <div className={rowClassName}>
        <div className="flex gap-2">
          <CalendarIcon width={18} height={18} color={iconColor} />
          {formattedDate}
        </div>
        <div className="flex gap-2">
          <ClockIcon width={18} height={18} color={iconColor} />
          {formattedTime}
        </div>
      </div>
      <div className={cn(rowClassName, 'w-full justify-between md:w-auto md:justify-start')}>
        <div className="flex gap-2">
          <ShipShortIcon width={18} height={18} color={iconColor} />
          <p className="uppercase">{vesselTitle}</p>
        </div>

        <div className="flex items-center gap-6">
          {cancelled && (
            <div className="bg-error-medium-light flex gap-3 rounded-lg px-2 py-1 text-base text-white uppercase">
              {cancelledByAdmin ? getTranslation('cancelledSail') : getTranslation('cancelled')}
            </div>
          )}

          <div className="flex gap-10 leading-none md:hidden">
            <NumberOfTicketItems iconType="passenger" count={numOfPassengers} />
            <NumberOfTicketItems iconType="bicycle" count={numOfCycles} />
          </div>
        </div>
      </div>
      <div className="hidden gap-10 leading-none md:flex md:justify-end">
        <NumberOfTicketItems iconType="passenger" count={numOfPassengers} />
        <NumberOfTicketItems iconType="bicycle" count={numOfCycles} />
      </div>
    </RowContainer>
  )
}

export default DepartureAndVesselInfo
